<a
  *transloco="let t; scope: 'uiComponents'"
  class="p-button p-button-text bd-toolbar-button bd-logo-button bd-round-left inline-flex"
  [class.bd-round-right]="isLastToolbarItem()"
  [routerLink]="routerLink()"
  data-id="logo"
  [attr.aria-label]="t('uiComponents.navigation.logoButtonInfo')"
  (click)="logoClicked.emit()"
>
  <i class="ui-logo" aria-hidden="true"></i>
</a>
